import React, { Component } from 'react'
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import { CountryGroupActions, CountryActions } from 'actionsets'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import FormMixin from 'containers/shared/FormMixin'
import { WordDivider, MultiAutoSuggest } from 'components'
export class Form extends FormMixin(Component){

  constructor(props){
    super(props)
    CountryGroupActions.bindActions(this)
    CountryActions.bindActions(this, 'countries')
    this.onSaveRoute = '/countries'
  }

  get formObject(){
    return this.props.countryGroup
  }

  get selectedCountriesById(){
    return new Map(this.attribute('countries').map(country => [country.id, country]))
  }

  countryLabelProvider = ({name, iso3, continent }) =>{
    return `${name} (${iso3}-${continent})`
  }

  filterSeenCountries = callback => results => {
    const selected = this.selectedCountriesById
    callback(results.filter(({id}) => !selected.get(id)))
  }

  provideCountries = (query, callback, error) =>
    this.actions.countries.search(query).then(this.filterSeenCountries(callback)).catch(error)

  get updatedFormObject(){
    const base = super.updatedFormObject
    base.countryIds = base.countries.map(({id}) => id)
    return base
  }

  render = () => {
    const { Card, CardContent, CardActions, Button, TextField } = this
    return (
      <div style={{width: '100%'}}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant='h6' className={styles.headline}>Edit Country Group: {this.props.countryGroup.name}</Typography>
          </Toolbar>
        </AppBar>
        <Card style={{maxWidth: 400}}>
          <CardContent>
            <TextField attribute='name' autoFocus={true}/>
            <WordDivider word='countries'/>
            <MultiAutoSuggest
              fullWidth
              values={this.attribute('countries')}
              onChange={this.attributeChanged('countries')}
              labelProvider={this.countryLabelProvider}
              onSuggestionsFetchRequested={this.provideCountries}
              placeholder='Select Countries'
            />
          </CardContent>
          <CardActions className={styles.actions}>
            <Button onClick={() => this.props.history.push(this.onSaveRoute)} className={styles.save} >Cancel</Button>
            <Button onClick={this.save} className={styles.save} variant='contained' color='primary'>Save</Button>
          </CardActions>
        </Card>
      </div>
    )
  }

}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column'
  },
  card: {
     flex: '0 1',
    maxWidth: 900,
    alignSelf: 'stretch',
    margin: '10px auto',
    width: '100%'
  },
  actions: {
    display: 'flex',
    justifyContent: 'end'
  }
})

export default connect(({countryGroups}) => countryGroups)(Dependent({loader: true, wrapperClassName: styles.wrapper})(Form))